import styled from 'styled-components';

export const ReviewTagSpan = styled.span`
  width: 33%;
`;
